import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Class name combiner used by every shadcn-style component.
 * Merges Tailwind classes intelligently (later classes win on conflict).
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
